

document.querySelectorAll('.video_play_btn').forEach(button => {
    button.addEventListener('click', function() {
        const parent = this.closest('.video_box');
        const video = parent.querySelector('video');
        
        if (video) {
            video.play();
            this.style.display = 'none'; // Hide the play button
        }
    });
});

$(document).ready(function () {
   
      $(".img_dot").on("mouseenter", function () {
          $(this).closest(".image-banner").find(".image_dots_layer").fadeIn();
          
      });
  
      $(".img_dot").on("mouseleave", function () {
          $(this).closest(".image-banner").find(".image_dots_layer").fadeOut();
      });
  });

  $(document).ready(function () {
    $(".ingredient-item-slide").on("click", function () {
        let $popupInner = $(this).find(".sidebar-ingredient-popup-inner").clone(); // Clone the element
        $(".ingredient-side-popup-wrapper").empty().append($popupInner); // Clear and append new element
        $('.ingredient-side-popup').addClass('active');
        $('.ingredient-side-popup-layer').show();
        $('body').addClass('o-hidden');
    });

    $('.ingredient-side-popup-layer,.ingredient-popup-close').click(function(){
        $('.ingredient-side-popup').removeClass('active');
        $('.ingredient-side-popup-layer').hide();
        $('body').removeClass('o-hidden');
    })
    
});

$(document).ready(function () {
    $(".ing-category-list button").on("click", function () {
        let handle = $(this).data("handle"); // Get the clicked button's data-handle

        // Remove active class from all buttons and add it to the clicked button
        $(".ing-category-list button").removeClass("active");
        $(this).addClass("active");

        // If the button has the "show-all" class, show all slides
        if ($(this).hasClass("show-all")) {
            $(".ingredient-list-grid .image-grid-slide").show();
        } else {
            // Hide all slides first
            $(".ingredient-list-grid .image-grid-slide").hide();

            // Show only those that match the selected category
            $(".ingredient-list-grid .image-grid-slide").each(function () {
                let categories = $(this).attr("data-categories"); // Get the data-categories attribute

                // Ensure categories exist and check if it includes the handle
                if (categories && categories.split(" ").includes(handle)) {
                    $(this).show();
                }
            });
        }
    });
});

$(document).ready(function () {
    $('.img_dot').on('click', function (e) {
      if ($(window).width() < 768) {
        e.stopPropagation(); // Prevent click from bubbling up
        var $clickedDot = $(this);
        var $dotBlock = $clickedDot.closest('.image_dot_block');
        var $dotText = $dotBlock.find('.image_dot_text').html();
  
        // Update the mobile content viewer
        $('.mobile-conten-viewer-inner').empty().append($dotText);
  
        // Handle active class
        $('.img_dot').removeClass('active');
        $clickedDot.addClass('active');
        $('.mobile-content-viewer').addClass('active');
      }
    });
  
    $('.image-and-dots-sect .image-banner__outer-container').on('click', function (e) {
      if (!$(e.target).closest('.img_dot').length) {
        $('.img_dot').removeClass('active');
        $('.mobile-content-viewer').removeClass('active');
      }
    });
  });
  


  

document.addEventListener("DOMContentLoaded", function () {
  const urlParams = new URLSearchParams(window.location.search);
  const customerPosted = urlParams.get("customer_posted");

  if (customerPosted === "true") {
    console.log("Customer posted form." ,  document.querySelector(".popup__success-message"));
    document.querySelector("body").classList.add("popup-success-message");
    // Perform any action here, e.g., show thank you message
  }
});
